export default function MobileStickyCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden px-3 pb-3 pt-2 glass-strong border-t border-background-200/50">
      <div className="grid grid-cols-2 gap-2">
        <a
          href="tel:+558534942701"
          className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg border border-background-300 text-foreground-800 text-sm font-semibold cursor-pointer whitespace-nowrap"
        >
          <i className="ri-phone-fill text-base"></i>
          Ligar
        </a>
        <a
          href="https://wa.me/558534942701"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/20"
        >
          <i className="ri-whatsapp-line text-base"></i>
          WhatsApp
        </a>
      </div>
    </div>
  );
}